import { addPermissionsToRoute } from '@qsrsoft/myq-core';

const routes = {
  name: 'Cash',
  icon: 'mdi-cash',
  path: '/reports/cash/',
  children: [
    {
      path: '/reports/cash/cashStatistics',
      name: 'Cash Statistics',
      meta: { id: 'reports-cashStatistics' },
      component: () => import('./cashStatistics.vue'),
      ...addPermissionsToRoute(['cashStatistics']),
    },
  ]
};

export default routes;